export function initLottieIcon() {
	console.log("lottie");
	const elements = document.querySelectorAll(".bananau-lottie-icon");
	if (!elements.length) return;

	const callback = (entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;

			const el = entry.target;
			observer.unobserve(el);

			const src = el.dataset.lottieSrc;
			if (!src || !window.lottie) return;

			const anim = window.lottie.loadAnimation({
				container: el,
				renderer: "svg",
				loop: false,
				autoplay: true,
				path: src,
			});

			anim.addEventListener("complete", () => {
				anim.goToAndStop(anim.totalFrames - 1, true);
			});
		});
	};

	const options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.3,
	};

	const observer = new IntersectionObserver(callback, options);

	elements.forEach((el) => observer.observe(el));
}
